import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SnapshotSharedVariablesService } from 'src/app/modules/snapshot/Services/snapshot-shared-variables.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-header-section-list',
  templateUrl: './header-section-list.component.html',
  styleUrls: ['./header-section-list.component.css']
})
export class HeaderSectionListComponent implements OnInit, OnChanges {
  @Input() clientSnapDetails: any;
  snapshotListData: any;
  selected_Snap: string = "";


  constructor(private router: Router, private clientDetails: SnapshotSharedVariablesService, private _configService: SnapshotService, private _loaderService: LoaderService) {
    //this.landingdata = this.router.getCurrentNavigation()?.extras.state;
  }
  ngOnChanges(changes: SimpleChanges): void {
    //throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    this.snapshotListData = this._configService.SnapshotList;
    this.selected_Snap = this.clientSnapDetails.study;
  }

  showSnapshotDropdownVal: boolean = false;
  showSnapshotDropdown() {
    this.showSnapshotDropdownVal = !this.showSnapshotDropdownVal;
  }

  navigateSnapshot(selectedSnap: string) {
    this._loaderService.showLoader();

    this._configService
      .getClientStudyData({
        client_code: this.clientSnapDetails.client_code,
        snapshot_name: selectedSnap,
      })
      .subscribe(async (b) => {
        var x = JSON.parse(b.body.Data);
        if (
          x != null &&
          x != undefined &&
          x != ''
        ) {
          let mainStudy = x.study_list[0].study_name;
          // let data: { client_code: string; study: string } = {
          //   client_code: this.selectedClientCode,
          //   study: this.selectedStudy,
          // };

          let data: { client_code: string; study: string; main_study: string; study_category: string, snapList: any } = {
            client_code: this.clientSnapDetails.client_code,
            study: selectedSnap,
            main_study: mainStudy,
            study_category: x.category || '',
            snapList: this._configService.SnapshotList
          };

          if (x.product == "Standard") {
            this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
          }
          else if (x.product == "Custom") {
            //this.router.navigate(['Snapshot', 'custom-snapshot-output'], { state: data });
            //this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
            this.router.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data});
            });
          //   this.router.navigateByUrl('dummy').then(() => {
          //     this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
          // });
          }

        }
        else {
          this.router.navigateByUrl('landing');
        }
      })


  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (event.target.id !== 'snapshot-dropdown' && event.target.id !== 'snapshot-text') {
      this.showSnapshotDropdownVal = false;
    }
  }

}
